/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Organization_Bc_Sync_Not_AllowedInputs */

const en_error_organization_bc_sync_not_allowed = /** @type {(inputs: Error_Organization_Bc_Sync_Not_AllowedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The record cannot be sent to Business Central now.`)
};

/**
* | output |
* | --- |
* | "The record cannot be sent to Business Central now." |
*
* @param {Error_Organization_Bc_Sync_Not_AllowedInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const error_organization_bc_sync_not_allowed = /** @type {((inputs?: Error_Organization_Bc_Sync_Not_AllowedInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Organization_Bc_Sync_Not_AllowedInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_error_organization_bc_sync_not_allowed(inputs)
});